export default __webpack_public_path__ + "static/media/flp_icon.ef02d046.svg";